<template>
  <div class="page">
    <div class="main">
      <div class="login">选择充值套餐系列</div>

      <div v-for="(item, index) in allChangeList" class="more-list-item" :key="index" @click="selectIon(item, index)"
        :class="{ 'active': index === inx }">
        <div class="num">{{ item.groupName }}</div>
        <div class="num-small">{{ item.groupRemark }}</div>
      </div>

      <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">确定套餐</van-button>
      <div class="prompt" :style="{ 'margin-top': height + 'px' }">
        <div class="prompt-top">温馨提示</div>
        <div class="prompt-name">1、若对套餐系列有疑问，可联系销售处理。</div>
        <div class="prompt-name">2、请注意套餐选择后，后续不可更改。</div>
      </div>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant'
export default {
  components: {
  },
  data() {
    return {
      allChangeList: [],
      nowGroup: localStorage.getItem('nowGroup'),
      iccid: localStorage.getItem('iccid'),
      recordLoginText: localStorage.getItem('recordLoginText'),
      inx: 0,
      height: '',
      selectGroupId: '',// 用户最终选择的套餐ID  groupId
    }
  },
  watch: {

  },
  mounted() {
    this.allChangeList = JSON.parse(decodeURIComponent(escape(window.atob(localStorage.getItem('allChangeList')))));
    this.selectGroupId = this.allChangeList[0].groupId || ''
    this.height = document.documentElement.clientHeight - 610;
  },
  methods: {
    selectIon(item, index) {
      this.inx = index
      this.selectGroupId = item.groupId
    },

    onSubmit() {
      var data = {
        iccid: this.iccid,
        basePkgGroup: this.selectGroupId
      }
      wxRequest('sim/update/group', data, 'post').then(res => {
        if (res.data.code === '200') {
          this.userQuerySIM();
        } else {
          Toast.fail(res.data.message)
        }
      })
    },

    userQuerySIM() {
      if (this.iccid == '') {
        Dialog.alert({ title: '提示', message: '请输入ICCID号' })
        return false;
      }
      let data = {
        requestId: this.recordLoginText,
        code: "1"
      }
      wxRequest("sim/bind", data, "get").then(res => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          if (record.titleMap) {
            localStorage.setItem("wxTitle", record.titleMap.title);
            localStorage.setItem("wxText", record.titleMap.context);
            localStorage.setItem("wxUrls", record.titleMap.urls);
          } else {
            localStorage.setItem("wxTitle", '');
            localStorage.setItem("wxText", '');
            localStorage.setItem("wxUrls", '');
          }
          localStorage.setItem('isNewPage', record.isNewPage);
          this.$store.state.isNewPage = record.isNewPage;
          localStorage.setItem('newHomeImg', record.newHomeImg);
          localStorage.setItem('newHomeImg2', record.newHomeImg2);
          localStorage.setItem('newHomeUrl', record.newHomeUrl);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("isBindPhone", record.isBindPhone);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("iccid", iccid);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("phoneNo", record.userPhone);
          localStorage.setItem("userPhone", record.userPhone);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("agentId", record.agentId);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.state.flowRatePool = res.data.data.flowRatePool;
          this.$store.state.intoNo = record.intoNo;

          if (record.isToYuCun != 1) {
            this.$router.replace("/user/openPrice");
          } else {
            let _data = { iccid: record.iccid };
            wxRequest("bindPhone/state", _data, "post").then((res) => {
              if (res.data.code == 200) {
                let result = res.data.data;
                localStorage.setItem(
                  "applyChangeSimState",
                  result.applyChangeSimState
                );
                if (result.bindState == 2) {
                  this.$router.push({
                    path: "/userNew/bindPhone",
                    query: {
                      iccid: record.iccid,
                    },
                  });
                } else {
                  if (record.isNewPage == 0) {
                    this.$router.replace('/user/home');
                  } else if (record.isNewPage == 1) {
                    this.$router.replace('/userNew/home');
                  } else if (record.isNewPage == 2) {
                    this.$router.replace('/user/homeNew');
                  } else if (record.isNewPage == 3) {
                    this.$router.replace('/new/home');
                  }
                }
              } else {
                Dialog.alert({ title: "提示", message: res.data.message });
              }
            });
          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.more-list-item {
  height: 60px;
  width: 80%;
  padding-left: 20px;
  font-size: 20px;
  background: #fff;
  margin: auto;
  margin-bottom: 20px;
  border: 1px solid #fff;
  margin-top: 14px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .num{
    font-weight: bold; 
    margin-bottom:7px;
  }
  .num-small{
    font-size: 12px;
    color:#999;
  }
}

.more-list-item.active {
  background: #eef7ff;
  border: 1px solid #1989fa;
}

.page {
  background: #F7F8FA url('../../assets/userNew/icon4.png') no-repeat top center;
  background-size: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;

  .main {
    flex: 1;
    display: flex;
    align-items: stretch;
    flex-direction: column;

    .login {
      margin: 60px 0px 0px 24px;
      font-size: 28px;
      color: rgb(6, 18, 30);
      font-weight: bold;
    }

    .login-text {
      color: #707070;
      font-size: 16px;
      margin-left: 24px;
      margin-top: 14px;
      line-height: 20px;
      width: 90%;
    }

    .captcha {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }

    .ph-input {
      margin: 40px 24px 20px;
      height: 60px;
      border-bottom: 1px solid #e3e2e2;
      flex-direction: row;
      align-items: center;
      flex-grow: 0;
      display: flex;

      .ph-text {
        color: #06121e;
        width: 50px;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
      }

      .ph-t {
        color: #06121e;
        flex: 1;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
        padding: 0;
        background: none;

        ::v-deep .van-field__left-icon {
          .van-icon {
            font-size: 22px;
          }
        }

        ::v-deep.van-cell__value {
          .van-field__control {
            background: none;
            padding-left: 14px;
            color: #000;
            line-height: 50px;
            height: 50px;
          }
        }
      }

      .ph-t-icon {
        background: url('../../assets/userNew/icon7.png') no-repeat left center;
        background-size: 23px 18px;
        padding-left: 20px;
      }

      .ph-t-icon1 {
        background: url('../../assets/userNew/icon5.png') no-repeat left center;
        background-size: 15px 22px;
        padding-left: 20px;
      }

      .ph-t-icon2 {
        background: url('../../assets/userNew/icon6.png') no-repeat left center;
        background-size: 19px 22px;
        padding-left: 20px;
      }
    }

    .bu_tn {
      width: 230px;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #3476fe;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }

    .bu_tn-a {
      width: 80%;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #fff;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }
  }

  .prompt {
    padding: 18px;
    width: 80%;
    background: #fff;
    border-radius: 10px;
    margin: auto;

    .prompt-top {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-left: 22px;
      background: url('../../assets/userNew/icon2.png') no-repeat left center;
      background-size: 17px 12px;
    }

    .prompt-name {
      color: #646668;
      font-size: 12px;
      line-height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>